import type { LocationQueryRaw, RouteRecordRaw } from 'vue-router';

import { slugify } from '@/utils/slugify';
import { parseHashParams } from '@/utils/urlParams';
import EventDetailView from '@/views/EventDetailView.vue';

/**
 * Legacy redirect routes from older URL formats (NG, search, etc.)
 * These handle old bookmarks and external links that still use deprecated URL patterns.
 */
export const legacyRedirectRoutes: RouteRecordRaw[] = [
  {
    path: '/:path(events|event|no|de|help|about|vejledning|ticketerror)',
    redirect: '/',
  },
  {
    path: '/search/category/:category',
    redirect: to => ({ path: '/', query: { category: to.params.category as string } }),
  },
  {
    path: '/search/location/:location',
    redirect: to => ({ path: '/', query: { location: to.params.location as string } }),
  },
  {
    path: '/search/calendar/:date',
    redirect: (to) => {
      const [day, month, year] = (to.params.date as string).split('.');
      const timestamp = Date.UTC(+year, +month - 1, +day) / 1000;
      if (isNaN(timestamp)) return { path: '/' };
      return { path: '/', query: { date: timestamp.toString() } };
    },
  },
  {
    path: '/:id([0-9a-f]{96})',
    component: EventDetailView,
    beforeEnter: (to) => {
      if (to.hash.startsWith('#modal')) {
        const hashParams = parseHashParams(to.hash);
        const query: LocationQueryRaw = { ...to.query, ...hashParams };
        return { name: 'checkout-tickets', params: { id: to.params.id as string }, query, hash: '' };
      }
      return { name: 'event-detail', params: { id: to.params.id } };
    },
  },
  {
    path: '/:id(\\d+)/:name?',
    component: EventDetailView,
    beforeEnter: (to) => {
      if (to.hash.startsWith('#modal')) {
        const hashParams = parseHashParams(to.hash);
        const query: LocationQueryRaw = { ...to.query, ...hashParams };
        const name = to.params.name ? slugify(to.params.name as string) : 'event';
        return { name: 'checkout-tickets', params: { id: to.params.id as string, name }, query, hash: '' };
      }
      return { name: 'event-detail', params: { id: to.params.id, name: to.params.name } };
    },
  },
];
